import { useLocation } from "react-router";

import NavigationBar from "../Common/NavigationBar";
import AuthorizedRoute from "../Routes/AuthorizedRoutes";
import MiljokontrollOversiktPage from "./Miljokontroll/MiljokontrollOversiktPage";
import MiljogebyrerOversikt from "./Oversikt/OversiktContainer";
import TilBehandlingContainer from "./TilBehandling/TilBehandlingContainer";

import { authorized } from "../../utils/authorizationUtils";

import {
  bypatruljen,
  juridisk,
  stedfortrederDriftsleder,
} from "../../constants/roles";
import paths from "../../constants/sitePaths";

export default function MiljogebyrerPage() {
  const location = useLocation();

  const getNavigationItems = () => {
    if (authorized([stedfortrederDriftsleder])) {
      return [
        {
          navn: "Miljøgebyroversikt",
          path: paths.miljogebyrer.oversikt.shortUrl,
        },
      ];
    } else if (
      authorized([
        bypatruljen.saksbehandleradmin,
        bypatruljen.saksbehandler,
        bypatruljen.driftleder,
        juridisk.saksbehandler,
      ])
    ) {
      return [
        {
          navn: "Miljøgebyroversikt",
          path: paths.miljogebyrer.oversikt.shortUrl,
        },
        {
          navn: "Til behandling",
          path: paths.miljogebyrer.tilBehandling.shortUrl,
        },
        {
          navn: "Tidskontrolloversikt",
          path: paths.miljogebyrer.miljokontrolloversikt.shortUrl,
        },
      ];
    } else if (
      authorized([...Object.values(bypatruljen), ...Object.values(juridisk)])
    ) {
      return [
        {
          navn: "Miljøgebyroversikt",
          path: paths.miljogebyrer.oversikt.shortUrl,
        },
        {
          navn: "Til behandling",
          path: paths.miljogebyrer.tilBehandling.shortUrl,
        },
        {
          navn: "Tidskontrolloversikt",
          path: paths.miljogebyrer.miljokontrolloversikt.shortUrl,
        },
      ];
    }
  };

  const renderContent = () => {
    const pathname = location?.pathname || "";
    const roles = [...Object.values(bypatruljen), ...Object.values(juridisk)];

    if (pathname.startsWith(paths.miljogebyrer.tilBehandling.shortUrl)) {
      return (
        <AuthorizedRoute roles={roles}>
          <TilBehandlingContainer />
        </AuthorizedRoute>
      );
    }

    if (
      pathname.startsWith(paths.miljogebyrer.miljokontrolloversikt.shortUrl)
    ) {
      return (
        <AuthorizedRoute roles={roles}>
          <MiljokontrollOversiktPage />
        </AuthorizedRoute>
      );
    }

    return (
      <AuthorizedRoute roles={roles}>
        <MiljogebyrerOversikt />
      </AuthorizedRoute>
    );
  };

  return (
    <div>
      <NavigationBar navigationItems={getNavigationItems()} />
      {renderContent()}
    </div>
  );
}
